import React from 'react';
import { Toolbar, Typography, Box, Button } from '@mui/material';
import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useBranches } from '@/app/modules/ECommerce/pages/miniPOS/hooks/useBranches';
import { useAppAliasIntlFormatter } from '@/app/hooks/formatFeatureName';

export default function BranchAppBar() {
  const formatMessage = useAppAliasIntlFormatter();
  const history = useHistory();
  const { shop } = useSelector(state => state.auth);
  const { selectedBranch, filteredBranches, shouldSelectBranch } = useBranches();

  const handleSwitchBranch = () => {
    history.push({
      pathname: `/shop/${shop.seqId}/mini-pos/branch`,
      state: { from: history.location.pathname }
    });
  };

  return (
    shouldSelectBranch &&
    filteredBranches.length > 0 && (
      <Toolbar sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <Typography variant="body1" sx={{ color: '#6b7280' }}>
            {formatMessage({ id: 'mini.pos.branch' })}:
          </Typography>
          <Typography variant="body1" sx={{ fontWeight: 700, color: '#1a1a1a' }}>
            {selectedBranch?.name || '-'}
          </Typography>
        </Box>
        <Button
          variant="outlined"
          size="small"
          onClick={handleSwitchBranch}
          sx={{
            textTransform: 'none',
            borderColor: '#d1d5db',
            color: '#374151',
            fontWeight: 600,
            borderRadius: 1.5,
            px: 2,
            '&:hover': {
              borderColor: '#9ca3af',
              backgroundColor: '#f9fafb'
            }
          }}
        >
          {formatMessage({ id: 'mini.pos.branch.switch' })}
        </Button>
      </Toolbar>
    )
  );
}
